/*
 * Rooby Prime — product card quick actions.
 * Fully isolated: does not call into or modify Dawn's own
 * quick-add / cart-drawer / cart-notification code. Uses
 * Shopify's standard /cart/add.js Ajax endpoint directly.
 *
 * Favorite toggle: visual/local only (localStorage), no
 * backend wishlist app connected yet. Structure is ready to
 * swap in a real wishlist app later without changing markup.
 */
(function () {
  var STORAGE_KEY = 'rp_favorites';

  function getFavorites() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveFavorites(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* localStorage unavailable — favorite state just won't persist */
    }
  }

  function setFavoriteState(button, isActive) {
    button.classList.toggle('is-active', isActive);
    button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  }

  function initFavorites(root) {
    var buttons = root.querySelectorAll('[data-rp-favorite]');
    var favorites = getFavorites();

    buttons.forEach(function (button) {
      var id = button.getAttribute('data-product-id');
      setFavoriteState(button, favorites.indexOf(id) !== -1);

      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var current = getFavorites();
        var index = current.indexOf(id);
        var nowActive;

        if (index === -1) {
          current.push(id);
          nowActive = true;
        } else {
          current.splice(index, 1);
          nowActive = false;
        }

        saveFavorites(current);
        setFavoriteState(button, nowActive);
      });
    });
  }

  function initQuickAdd(root) {
    var buttons = root.querySelectorAll('[data-rp-quick-add]');

    buttons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (button.classList.contains('is-loading')) {
          return;
        }

        var variantId = button.getAttribute('data-variant-id');
        if (!variantId) {
          return;
        }

        button.classList.add('is-loading');

        fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (response) {
            return response.json().then(function (data) {
              return { ok: response.ok, data: data };
            });
          })
          .then(function (result) {
            button.classList.remove('is-loading');

            if (result.ok) {
              button.classList.add('is-added');
              setTimeout(function () {
                button.classList.remove('is-added');
              }, 1800);

              // Let the rest of the theme (cart count bubble, cart drawer,
              // notifications) know the cart changed, using a generic
              // event name so existing or future listeners can pick it up.
              document.dispatchEvent(
                new CustomEvent('cart:refresh', { bubbles: true })
              );
            }
            // On failure (e.g. sold out between page load and click), the
            // button simply resets — no cart change, no broken redirect.
          })
          .catch(function () {
            button.classList.remove('is-loading');
          });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initFavorites(document);
    initQuickAdd(document);
  });
})();
